export default {"src":"/_next/static/media/DiggerIcon.24632f98.svg","height":82,"width":82};